import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from '@mui/material';
import { CustomTableCell } from '../../index';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { formatISOToPHT } from '../../../utilities/date';

export const WorkExpComponent = (props) => {
  return (
    <Box sx={{ mb: 3, padding: '12px' }}>
      <TableContainer
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
          padding: '12px',
        }}
      >
        <Table sx={{ width: '100%' }}>
          <TableHead>
            <TableRow>
              <CustomTableCell value="Company/Institution" />
              <CustomTableCell value="Position" />
              <CustomTableCell value="Start Date" />
              <CustomTableCell value="End Date" />
              <CustomTableCell value="Monthly Salary" />
              <CustomTableCell value="Status" />
              <CustomTableCell
                value="Government"
                sx={{ textAlign: 'center' }}
              />
            </TableRow>
          </TableHead>
          {props.empWorkExp?.map((workexp) => (
            <TableRow key={workexp._id}>
              <CustomTableCell scope="row" value={workexp.placeofemployment} />
              <CustomTableCell scope="row" value={workexp.position} />
              <CustomTableCell
                scope="row"
                value={formatISOToPHT(workexp.startdate)}
              />
              <CustomTableCell
                scope="row"
                value={formatISOToPHT(workexp.enddate)}
              />
              <CustomTableCell scope="row" value={workexp.monthlysalary} />
              <CustomTableCell scope="row" value={workexp.status} />
              <TableCell>
                {workexp.government ? (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <CheckCircleIcon />
                  </Box>
                ) : null}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </TableContainer>
    </Box>
  );
};
